export async function fetchBlob(url: string, success: (blob: Blob) => void, failure: () => void) {
  let headers = new Headers()
  headers.set("responseType", "blob")

  fetch(
    url,
    { headers: headers }
  )
    .then(response => response.blob())
    .then(blob => success(blob))
    .catch(failure)
}

export function canShare(imageBlob: Blob) {
  let files = getFilesToShare(imageBlob)
  try {
    return navigator && (navigator as any).canShare({ files })
  } catch {
    return false
  }
}

export function webShare(imageBlob: Blob) {
  navigator.share({
    files: getFilesToShare(imageBlob)
  } as any)
    .then(() => console.log('Share was successful.'))
    .catch((error) => console.log('Sharing failed', error))
}

function getFilesToShare(imageBlob: Blob): File[] {
  return [new File([imageBlob], 'photo.jpg', { type: imageBlob.type })]
}

export function saveFile(blob: Blob, filename: string, extension: string) {
  // See Stackoverflow discussion: https://stackoverflow.com/questions/49474775/chrome-65-blocks-cross-origin-a-download-client-side-workaround-to-force-down
  let blobUrl = window.URL.createObjectURL(blob)

  var a = document.createElement('a')
  a.download = `${filename}.${extension}`
  a.href = blobUrl
  document.body.appendChild(a)
  a.click()
  a.remove()
}
